// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_loaderConatiner__tp4mc {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0rem;
}

.Loader_loader__\\+lRPl {
	position: absolute;
	top: 50%;
	right: 50%;
	transform: translate(-50%, -50%);
  border: 8px solid var(--heart-icon-default);
  border-top: 8px solid var(--button-link-color);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: Loader_spin__E4RJ0 1s linear infinite;
}

@keyframes Loader_spin__E4RJ0 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,gCAAgC;EAC/B,2CAA2C;EAC3C,8CAA8C;EAC9C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".loaderConatiner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 2rem 0rem;\n}\n\n.loader {\n\tposition: absolute;\n\ttop: 50%;\n\tright: 50%;\n\ttransform: translate(-50%, -50%);\n  border: 8px solid var(--heart-icon-default);\n  border-top: 8px solid var(--button-link-color);\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderConatiner": `Loader_loaderConatiner__tp4mc`,
	"loader": `Loader_loader__+lRPl`,
	"spin": `Loader_spin__E4RJ0`
};
export default ___CSS_LOADER_EXPORT___;
